export enum MetricReportGroupStatusEnum {
    new = 'NEW',
    done = 'DONE',
    cancel = 'CANCEL',
    future = 'FUTURE',
}
